"use strict";

define('components/filter_bar/table/bulk_download',['components/ajax'], function(ajax) {
    var bulkDownloadComponent = {
        initWithContext: function(context) {
            var downloadButton = context.buttonbarNode.find('.selection-download button');
            downloadButton.click(function() {
                var objectIds = context.tableFilterBarData.tableInstance.getSelectedObjectIds();
                
                var formData = new FormData();
                formData.append('ids', JSON.stringify(objectIds));

                var url = downloadButton.data('url');

                var modalContent =
                    '<div class="modal-header">' +
                    '  <h4 class="modal-title" id="waiting-title">' +
                    '    <img src="/static/spinner_sm.gif" width="16" height="16">&nbsp;' +
                    downloadButton.data('modal-title') +
                    '  </h4>' +
                    '</div>' +
                    '<div class="modal-body">' +
                    downloadButton.data('modal-body') +
                    '</div>';
                
                var waitingModal = $('#waiting-modal');

                waitingModal.find('.modal-content')
                            .html(modalContent);
                
                waitingModal.one('shown.bs.modal', function() {
                    ajax(url, {
                        formData: formData,
                        onComplete: function(result) {
                            waitingModal.modal('hide');
                        }
                    });
                });

                waitingModal.modal('show');
            });
        }
    };

    return bulkDownloadComponent;
});
